import { render, staticRenderFns } from "./FitnessRoutinesDetails.vue?vue&type=template&id=96601e54&"
import script from "./FitnessRoutinesDetails.vue?vue&type=script&lang=js&"
export * from "./FitnessRoutinesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports